<script lang="ts" setup>
import UiImage from '@/components/Ui/UiImage.vue';
import type {IVehicle} from '@/types/vehicle';
import {computed} from 'vue';

const props = defineProps<{ vehicle?: IVehicle }>()
const model = defineModel<string>()
const label = computed(() => props.vehicle ? `${props.vehicle.year} ${props.vehicle.make} ${props.vehicle.range}`.toUpperCase() : 'MY VEHICLE')

const dates = computed(() => {
  const options: { label: string, value?: string }[] = (props.vehicle?.registration_dates || [])
    .map(d => ({
      value: d,
      label: new Date(`${d}T00:00:00`).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
    }))
  options.push({
    value: 'NOT_SURE',
    label: 'Not Sure'
  })
  return options
})
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <UiImage
      :src="`https://cdn.imagin.studio/getImagem?make=${props.vehicle?.make || ''}&model=${props.vehicle?.model || ''}&modelYear=${props.vehicle?.year || ''}&customer=uk-johnsonlawgroup&countryCode=UK&fileType=jpg`"
      class="h-20 w-auto"/>

    <h2 class="text-lg font-bold mb-4">Confirm the date you first registered your {{ label }}</h2>

    <div class="space-y-4 mb-6 w-full">
      <label class="border border-gray-300 rounded-lg p-4 flex items-center justify-between"
             v-for="date in dates" :key="date.value">
        <span class="text-lg grow" :class="{'text-gray-400': !date.value}">{{
            date.label
          }}</span>
        <input :value="date.value" v-model="model" type="radio"
               class="h-5 w-5 text-blue-600 rounded">
      </label>
    </div>
  </div>
</template>
